import { css } from 'lit';

export const LIT_CSS_VARIABLES = css`
  :host {
    --default-rem-px-count: 16;
    --top-padding-height: calc(20rem / var(--default-rem-px-count));
    --bottom-padding-height: calc(20rem / var(--default-rem-px-count));

    --column-width: minmax(
      calc(100% / 320 * 37),
      calc(
        calc(320rem - (10 * var(--between-column-padding)) / 6) /
          var(--default-rem-px-count)
      )
    );
    --outer-padding: minmax(calc(2rem / var(--default-rem-px-count)), auto);
    --between-column-padding: calc(8rem / var(--default-rem-px-count));
    --between-row-padding: calc(20rem / var(--default-rem-px-count));
    --empty-row: '. . . . . . . .';
    --block-line-break: '. line-break line-break line-break line-break line-break line-break .';
    --images-row-with-gutter: '. images images images images images images .';
    --images-row-with-left-gutter: '. images images images images images images images';

    --grey-dark: #b2b2b2;
  }

  @media (min-width: 600px) {
    :host {
      --top-padding-height: calc(40rem / var(--default-rem-px-count));
      --bottom-padding-height: calc(50rem / var(--default-rem-px-count));
      --between-column-padding: calc(12rem / var(--default-rem-px-count));
      --empty-row: '. . . . . . . . . . . . . .';
      --block-line-break: '. line-break line-break line-break line-break line-break line-break line-break line-break line-break line-break line-break line-break .';
      --text-header-with-cta: '. header header header . description description description description description . cta cta .';
      --images-row-with-gutter: '. images images images images images images images images images images images images .';
      --images-row-with-left-gutter: '. images images images images images images images images images images images images images';
      --column-width: minmax(
        calc(100% / 800 * 45),
        calc(
          calc(800rem - (12 * var(--between-column-padding)) / 12) /
            var(--default-rem-px-count)
        )
      );
      --between-column-padding: calc(8rem / var(--default-rem-px-count));
      --outer-padding: minmax(calc(4rem / var(--default-rem-px-count)), auto);
    }
  }

  @media (min-width: 800px) {
    :host {
      --between-column-padding: calc(18rem / var(--default-rem-px-count));
      --text-header-with-cta: '. header header header . description description description description description . cta cta .';
      --column-width: minmax(
        calc(100% / 1024 * 60),
        calc(
          calc(1024rem - (12 * var(--between-column-padding)) / 12) /
            var(--default-rem-px-count)
        )
      );
    }
  }

  @media (min-width: 1024px) {
    :host {
      --top-padding-height: calc(60rem / var(--default-rem-px-count));
      --bottom-padding-height: calc(80rem / var(--default-rem-px-count));
      --between-column-padding: calc(24rem / var(--default-rem-px-count));
      --text-header-with-cta: '. header header header . description description description description . . cta cta .';
      --column-width: minmax(
        calc(100% / 1440 * 70),
        calc(
          calc(1440rem - (12 * var(--between-column-padding)) / 12) /
            var(--default-rem-px-count)
        )
      );
    }
  }

  @media (min-width: 1200px) {
    :host {
      --between-column-padding: calc(32rem / var(--default-rem-px-count));
    }
  }

  :host([hidden]) {
    max-width: 1440px;
    margin: 0 auto;
  }
`;

export const GRID_LAYOUT = css`
  .block-grid {
    display: inline-grid;
    grid-template-columns:
      var(--outer-padding)
      repeat(6, 1fr)
      var(--outer-padding);
    gap: calc(15rem / var(--default-rem-px-count)) var(--between-column-padding);
  }

  @media (min-width: 600px) {
    .block-grid {
      grid-template-columns:
        var(--outer-padding)
        repeat(12, 1fr)
        var(--outer-padding);

      gap: 0 var(--between-column-padding);
    }
  }
`;

export const DIALOG_STYLES = css`
  dialog {
    border: none;
    padding: none;
  }

  ::backdrop, /* for native <dialog> */
  dialog + .backdrop {
    /* for dialog-polyfill */
    background-color: rgba(0, 0, 0, 0.4);
  }

  dialog > #dialog-content {
    display: flex;
    flex-direction: column;
    max-width: 100%;
    padding: calc(32rem / var(--default-rem-px-count));
  }

  dialog > #dialog-content > .dialog-header {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-bottom: calc(40rem / var(--default-rem-px-count));
  }

  dialog > #dialog-content > .dialog-header > h3 {
    font-weight: 500;
    font-size: calc(20rem / var(--default-rem-px-count));
  }

  dialog > #dialog-content > .dialog-header > .close-btn {
    cursor: pointer;
  }

  dialog > #dialog-content > .dialog-body {
    display: flex;
    flex-direction: column;
    gap: calc(24rem / var(--default-rem-px-count));
  }

  dialog > #dialog-content > .dialog-body > .dialog-images {
    display: grid;
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: calc(20rem / var(--default-rem-px-count));
    padding-bottom: calc(20rem / var(--default-rem-px-count));
  }

  dialog
    > #dialog-content
    > .dialog-body
    > .dialog-images
    > .dialog-image-wrapper
    > img {
    max-width: 100%;
  }

  dialog
    > #dialog-content
    > .dialog-body
    > .dialog-images
    > .dialog-image-wrapper
    > :not(:last-child) {
    padding-bottom: calc(14rem / var(--default-rem-px-count));
  }
`;
